import WelcomePopup from 'components/WelcomePopup/WelcomePopup';
import withWelcomePopupProps from 'viewModel/welcomePopup/withWelcomePopupProps';

export default withWelcomePopupProps(WelcomePopup);
